import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import "./Reservation.css";

class Reservation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reservations: [],
      loading: true,
      error: null,

      // Guest Popup State
      selectedGuest: null,
      showGuestPopup: false,

      // Review Popup State
      showReviewPopup: false,
      selectedReviewBooking: null,
      reviewText: "",
      
      // Dynamic Rating Criteria State
      ratingCriteria: [
        { id: 1787314725651, label: "Rate Gusts Behavior", value: "5" },
        { id: 1787346727450, label: "Observance of House Rules", value: "5" },
        { id: 1787314725652, label: "Rate Guests Communication", value: "5" },
      ],
      newCriteriaLabel: "",

      comments: [],
      loadingComments: false,
      submittingReview: false,
    };
  }

  componentDidMount() {
    const web_user_id =
      localStorage.getItem("web_user_id") ||
      sessionStorage.getItem("web_user_id");

    if (
      !web_user_id ||
      web_user_id === "null" ||
      web_user_id === "undefined" ||
      String(web_user_id).trim() === ""
    ) {
      window.location.replace("/searchresultmobile");
      return;
    }

    this.fetchReservations(web_user_id);
  }

  fetchReservations = async (customerId) => {
    try {
      this.setState({
        loading: true,
        error: null,
      });

      const response = await axios.get(`/bookings_data/${customerId}`);
      const data = response?.data?.data;

      if (!Array.isArray(data)) {
        this.setState({
          reservations: [],
          loading: false,
        });
        return;
      }

      const filteredReservations = data.filter(
        (booking) =>
          String(booking.booking_status || "").trim().toLowerCase() === "confirmed" &&
          String(booking.payment_status || "").trim().toLowerCase() === "paid"
      );

      this.setState({
        reservations: filteredReservations,
        loading: false,
      });
    } catch (error) {
      console.error("Reservation fetch error:", error);
      this.setState({
        reservations: [],
        loading: false,
        error: "Unable to load reservations.",
      });
    }
  };

  // =========================================================
  // REVIEW & STAR RATING ACTIONS
  // =========================================================

  openReviewPopup = (booking) => {
    this.setState(
      {
        selectedReviewBooking: booking,
        showReviewPopup: true,
        reviewText: "",
        ratingCriteria: [
          { id: 1787314725651, label: "Rate Gusts Behavior", value: "5" },
          { id: 1787346727450, label: "Observance of House Rules", value: "5" },
          { id: 1787314725652, label: "Rate Guests Communication", value: "5" },
        ],
        newCriteriaLabel: "",
        comments: [],
      },
      () => {
        const postId = booking.post_id || booking.id;
        const bookingId = booking.id;
        this.fetchComments(postId, bookingId);
      }
    );
  };

  closeReviewPopup = () => {
    this.setState({
      selectedReviewBooking: null,
      showReviewPopup: false,
    });
  };

  handleReviewTextChange = (e) => {
    this.setState({ reviewText: e.target.value });
  };

  // Click handler for star ratings per criteria item
  handleStarClick = (id, ratingValue) => {
    this.setState((prevState) => ({
      ratingCriteria: prevState.ratingCriteria.map((item) =>
        item.id === id ? { ...item, value: String(ratingValue) } : item
      ),
    }));
  };

  // Dynamic criteria addition
  handleNewCriteriaChange = (e) => {
    this.setState({ newCriteriaLabel: e.target.value });
  };

  handleAddCriteria = () => {
    const { newCriteriaLabel, ratingCriteria } = this.state;
    if (!newCriteriaLabel.trim()) return;

    const newItem = {
      id: Date.now(),
      label: newCriteriaLabel.trim(),
      value: "5",
    };

    this.setState({
      ratingCriteria: [...ratingCriteria, newItem],
      newCriteriaLabel: "",
    });
  };

  handleRemoveCriteria = (id) => {
    this.setState((prevState) => ({
      ratingCriteria: prevState.ratingCriteria.filter((item) => item.id !== id),
    }));
  };

  fetchComments = async (postId, bookingId) => {
    this.setState({ loadingComments: true });
    const web_user_id =
      localStorage.getItem("web_user_id") ||
      sessionStorage.getItem("web_user_id");

    try {
      const response = await axios.get(
        `/get_all_comments_mobile_by_post_id?post_id=${postId}&booking_id=${bookingId}&customer_id=${web_user_id}&user_type=host`
      );
      if (response?.data?.status === "success" && Array.isArray(response.data.data)) {
        this.setState({ comments: response.data.data });
      } else {
        this.setState({ comments: [] });
      }
    } catch (error) {
      console.error("Fetch comments error:", error);
      this.setState({ comments: [] });
    } finally {
      this.setState({ loadingComments: false });
    }
  };

  submitReview = async () => {
    const { selectedReviewBooking, reviewText, ratingCriteria } = this.state;
    if (!reviewText.trim()) return;

    const web_user_id =
      localStorage.getItem("web_user_id") ||
      sessionStorage.getItem("web_user_id");

    const postId = selectedReviewBooking.post_id || selectedReviewBooking.id;
    const bookingId = selectedReviewBooking.id;
    const commentStarJson = JSON.stringify(ratingCriteria);

    this.setState({ submittingReview: true });
    try {
      await axios.get(
        `/comments/create?post_id=${postId}&customer_id=${web_user_id}&booking_id=${bookingId}&comment_details=${encodeURIComponent(
          reviewText
        )}&comment_star=${encodeURIComponent(commentStarJson)}&user_type=host`
      );
      this.setState({ reviewText: "" });
      this.fetchComments(postId, bookingId);
    } catch (error) {
      console.error("Submit review error:", error);
    } finally {
      this.setState({ submittingReview: false });
    }
  };

  // Parses comment_star JSON and calculates average out of 5
  calculateAverageRating = (commentStarString) => {
    try {
      const ratings = JSON.parse(commentStarString);
      if (!ratings || ratings.length === 0) return 0;
      const total = ratings.reduce((sum, item) => sum + parseInt(item.value, 10), 0);
      return (total / ratings.length).toFixed(1);
    } catch (e) {
      return 0;
    }
  };

  // =========================================================
  // UTILS
  // =========================================================

  formatDate = (date) => {
    if (!date) return "N/A";
    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) return date;
    return parsedDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  formatPrice = (price) => {
    if (price === null || price === undefined || price === "") return "N/A";
    const numericPrice = Number(price);
    if (Number.isNaN(numericPrice)) return price;
    return `৳${numericPrice.toLocaleString("en-BD")}`;
  };

  getGuestText = (booking) => {
    const adults = Number(booking.adults || 0);
    const children = Number(booking.children || booking.kids || 0);
    const guestParts = [];

    if (adults > 0) guestParts.push(`${adults} ${adults === 1 ? "Adult" : "Adults"}`);
    if (children > 0) guestParts.push(`${children} ${children === 1 ? "Child" : "Children"}`);

    return guestParts.length ? guestParts.join(", ") : "N/A";
  };

  handleCall = (phone) => {
    if (!phone) return;
    window.location.href = `tel:${phone}`;
  };

  // =========================================================
  // ICONS
  // =========================================================

  HomeIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3 10.8 12 3l9 7.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.5 9.5V21h13V9.5M9 21v-6h6v6" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  );

  CalendarIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M7.5 3v4M16.5 3v4M3.5 9.5h17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );

  UserIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M5.5 20c.7-3.6 2.8-5.5 6.5-5.5s5.8 1.9 6.5 5.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );

  PhoneIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M7.4 3.8 5.6 5.6c-.7.7-.8 1.8-.3 2.7 2.2 3.9 5.4 7.1 9.3 9.3.9.5 2 .4 2.7-.3l1.8-1.8c.6-.6.6-1.6.1-2.3l-1.7-2.3c-.5-.7-1.4-.9-2.1-.5l-1.6.8c-1.3-.8-2.4-1.9-3.2-3.2l.8-1.6c.4-.7.2-1.6-.5-2.1L9.7 3.7c-.7-.5-1.7-.5-2.3.1Z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  MessageIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M5 5.5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H10l-4.5 3v-3H5a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
      <path d="M7 10h10M7 13.5h6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );

  CloseIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="m7 7 10 10M17 7 7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );

  RefreshIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M20 11a8 8 0 0 0-14.8-4L3 10" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 5v5h5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
      <path d="M4 13a8 8 0 0 0 14.8 4L21 14" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 19v-5h-5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
    </svg>
  );

  EmptyIcon = () => (
    <svg viewBox="0 0 80 80" fill="none" aria-hidden="true">
      <rect x="15" y="20" width="50" height="40" rx="7" stroke="currentColor" strokeWidth="2.5" />
      <path d="M15 34h50M27 20v-5M53 20v-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M29 46h22M29 53h13" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );

  AlertIcon = () => (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2.5" />
      <path d="M24 14v12M24 32v2" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" />
    </svg>
  );

  EditIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  StarIcon = ({ filled = true }) => (
    <svg viewBox="0 0 24 24" fill={filled ? "#f59e0b" : "#cbd5e1"} aria-hidden="true">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );

  PlusIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );

  TrashIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  // =========================================================
  // MOBILE CARD
  // =========================================================

  renderMobileReservation = (booking) => {
    return (
      <article className="reservation-card" key={booking.id}>
        {/* TOP */}
        <div className="reservation-card-top">
          <div className="reservation-property-icon">
            <this.HomeIcon />
          </div>
          <div className="reservation-property-heading">
            <span className="reservation-booking-label">BOOKING #{booking.id}</span>
            <h3 className="reservation-property-title" title={booking.title}>
              {booking.title || "Property"}
            </h3>
          </div>
          <span className="reservation-status">
            <span className="reservation-status-dot" /> Confirmed
          </span>
        </div>

        {/* STAY */}
        <div className="reservation-stay-box">
          <div className="reservation-date-column">
            <span>CHECK-IN</span>
            <strong>{this.formatDate(booking.checkin_date)}</strong>
          </div>
          <div className="reservation-date-arrow">
            <span /><b>›</b><span />
          </div>
          <div className="reservation-date-column right">
            <span>CHECK-OUT</span>
            <strong>{this.formatDate(booking.checkout_date)}</strong>
          </div>
        </div>

        {/* META */}
        <div className="reservation-meta-grid">
          <div className="reservation-meta-item">
            <span className="reservation-meta-icon"><this.UserIcon /></span>
            <span>
              <small>Guests</small>
              <strong>{this.getGuestText(booking)}</strong>
            </span>
          </div>
          <div className="reservation-meta-item">
            <span className="reservation-meta-icon"><this.CalendarIcon /></span>
            <span>
              <small>Booked on</small>
              <strong>{this.formatDate(booking.booking_date)}</strong>
            </span>
          </div>
        </div>

        {/* PROPERTY ADDRESS */}
        {booking.real_address && (
          <div className="reservation-address">
            <this.HomeIcon />
            <span>{booking.real_address}</span>
          </div>
        )}

        {/* AMOUNT + PAYMENT */}
        <div className="reservation-footer">
          <div>
            <small>Total amount</small>
            <strong className="reservation-price">{this.formatPrice(booking.total_amount)}</strong>
          </div>
          <div className="reservation-payment">
            <small>Payment</small>
            <span className="reservation-payment-status">Paid</span>
          </div>
        </div>

        {/* ACTIONS */}
        <div className="reservation-actions">
          <button
            type="button"
            className="reservation-review-button"
            onClick={() => this.openReviewPopup(booking)}
          >
            <this.EditIcon />
            <span>Write a review</span>
          </button>

          <button
            type="button"
            className="reservation-guest-button"
            onClick={() => {
              this.setState({ selectedGuest: booking, showGuestPopup: true });
            }}
          >
            <this.UserIcon />
            <span>Guest Details</span>
          </button>

          <div className="reservation-action-row">
            <Link to="/chats" state={{ booking }} className="reservation-message-button">
              <this.MessageIcon />
              <span>Message</span>
            </Link>
            <button
              type="button"
              className="reservation-call-button"
              onClick={() => this.handleCall(booking.phone)}
            >
              <this.PhoneIcon />
              <span>Call</span>
            </button>
          </div>
        </div>
      </article>
    );
  };

  // =========================================================
  // GUEST POPUP
  // =========================================================

  renderGuestPopup = () => {
    const { selectedGuest, showGuestPopup } = this.state;
    if (!showGuestPopup || !selectedGuest) return null;

    return (
      <div className="reservation-popup-overlay" onClick={() => this.setState({ showGuestPopup: false })}>
        <div className="reservation-popup" onClick={(e) => e.stopPropagation()}>
          <div className="reservation-popup-header">
            <div>
              <span>BOOKING #{selectedGuest.id}</span>
              <h3>Guest Details</h3>
            </div>
            <button type="button" className="reservation-popup-close" onClick={() => this.setState({ showGuestPopup: false })} aria-label="Close">
              <this.CloseIcon />
            </button>
          </div>

          <div className="reservation-popup-status-row">
            <span className="reservation-status"><span className="reservation-status-dot" />Confirmed</span>
            <span className="reservation-payment-status">Paid</span>
          </div>

          <div className="reservation-popup-list">
            <div className="reservation-popup-item"><span>Name</span><strong>{selectedGuest.full_name || "N/A"}</strong></div>
            <div className="reservation-popup-item"><span>Phone</span><strong>{selectedGuest.phone || "N/A"}</strong></div>
            <div className="reservation-popup-item"><span>Email</span><strong>{selectedGuest.email || "N/A"}</strong></div>
            <div className="reservation-popup-item"><span>Property</span><strong>{selectedGuest.title || "N/A"}</strong></div>
            <div className="reservation-popup-item"><span>Check In</span><strong>{this.formatDate(selectedGuest.checkin_date)}</strong></div>
            <div className="reservation-popup-item"><span>Check Out</span><strong>{this.formatDate(selectedGuest.checkout_date)}</strong></div>
            <div className="reservation-popup-item"><span>Guests</span><strong>{this.getGuestText(selectedGuest)}</strong></div>
            <div className="reservation-popup-item"><span>Rooms</span><strong>{selectedGuest.rooms || "N/A"}</strong></div>
            <div className="reservation-popup-item"><span>Payment Type</span><strong>{selectedGuest.payment_type || "N/A"}</strong></div>
            <div className="reservation-popup-item"><span>Total Amount</span><strong className="popup-price">{this.formatPrice(selectedGuest.total_amount)}</strong></div>
            <div className="reservation-popup-item full"><span>Remarks</span><strong className="popup-remarks">{selectedGuest.remarks || "N/A"}</strong></div>
          </div>

          <div className="reservation-popup-actions">
            <button type="button" className="reservation-popup-call" onClick={() => this.handleCall(selectedGuest.phone)}>
              <this.PhoneIcon /> Call Guest
            </button>
            <Link to="/chats" state={{ booking: selectedGuest }} className="reservation-popup-message">
              <this.MessageIcon /> Message
            </Link>
          </div>
        </div>
      </div>
    );
  };

  // =========================================================
  // REVIEW POPUP WITH DYNAMIC GUEST RATING
  // =========================================================

  renderReviewPopup = () => {
    const {
      selectedReviewBooking,
      showReviewPopup,
      reviewText,
      ratingCriteria,
      newCriteriaLabel,
      comments,
      loadingComments,
      submittingReview,
    } = this.state;

    if (!showReviewPopup || !selectedReviewBooking) return null;

    return (
      <div className="reservation-popup-overlay" onClick={this.closeReviewPopup}>
        <div className="reservation-popup" onClick={(e) => e.stopPropagation()}>
          <div className="reservation-popup-header">
            <div>
              <span>BOOKING #{selectedReviewBooking.id}</span>
              <h3>Write a Review</h3>
            </div>
            <button type="button" className="reservation-popup-close" onClick={this.closeReviewPopup} aria-label="Close">
              <this.CloseIcon />
            </button>
          </div>

          <div className="review-form-section">
            {/* DYNAMIC GUESTS RATE SECTION */}
            <div className="rate-guests-container">
              <h4 className="rate-guests-title">Guests Rate</h4>
              
              <div className="rate-criteria-list">
                {ratingCriteria.map((item) => {
                  const currentValue = Number(item.value) || 0;
                  return (
                    <div className="rate-criteria-card" key={item.id}>
                      <div className="rate-criteria-header">
                        <span className="rate-criteria-label">{item.label}</span>
                        {item.id !== 1787314725651 && item.id !== 1787346727450 && item.id !== 1787314725652 && (
                          <button
                            type="button"
                            className="rate-remove-btn"
                            onClick={() => this.handleRemoveCriteria(item.id)}
                          >
                            <this.TrashIcon />
                          </button>
                        )}
                      </div>
                      <div className="rate-stars-row">
                        {[1, 2, 3, 4, 5].map((starNum) => (
                          <button
                            type="button"
                            key={starNum}
                            className={`star-btn ${starNum <= currentValue ? "active" : ""}`}
                            onClick={() => this.handleStarClick(item.id, starNum)}
                          >
                            <this.StarIcon filled={starNum <= currentValue} />
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* DYNAMIC CRITERIA ADDER */}
              <div className="add-criteria-wrapper">
                <input
                  type="text"
                  className="add-criteria-input"
                  placeholder="Add custom rating behavior..."
                  value={newCriteriaLabel}
                  onChange={this.handleNewCriteriaChange}
                />
                <button
                  type="button"
                  className="add-criteria-btn"
                  onClick={this.handleAddCriteria}
                >
                  <this.PlusIcon />
                  <span>Add</span>
                </button>
              </div>
            </div>

            {/* REVIEW COMMENT TEXTAREA */}
            <div className="review-form-group">
              <textarea
                className="review-textarea"
                placeholder="Share details of your experience with this stay..."
                value={reviewText}
                onChange={this.handleReviewTextChange}
              ></textarea>
            </div>

            <button
              className="review-submit-btn"
              onClick={this.submitReview}
              disabled={submittingReview || !reviewText.trim()}
            >
              {submittingReview ? "Submitting..." : "Submit Review"}
            </button>
          </div>

          {/* COMMENTS LISTING WITH STARS OVERHAUL */}
          <div className="comments-section">
            <h4 className="comments-title">All Review</h4>

            {loadingComments ? (
              <div className="comments-loading">Loading comments...</div>
            ) : comments.length > 0 ? (
              <div className="comments-list">
                {comments.map((comment) => {
                  const avgRating = this.calculateAverageRating(comment.comment_star);
                  const roundedRating = Math.round(avgRating);

                  return (
                    <div className="comment-item" key={comment.id}>
                      <div className="comment-header">
                        <span className="comment-name">{comment.full_name || "Guest"}</span>
                        <span className="comment-date">{this.formatDate(comment.comment_date)}</span>
                      </div>
                      
                      {/* Calculated Star View */}
                      <div className="comment-rating-row">
                        <div className="comment-stars">
                          {[1, 2, 3, 4, 5].map((starNum) => (
                            <this.StarIcon 
                              key={starNum} 
                              filled={starNum <= roundedRating} 
                            />
                          ))}
                        </div>
                        <span className="comment-rating-text">{avgRating} / 5</span>
                      </div>

                      <div className="comment-text">
                        {comment.comment_details}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="comments-loading">No past reviews found.</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // =========================================================
  // STATE RENDERS
  // =========================================================

  renderLoading = () => (
    <div className="reservation-state">
      <div className="reservation-spinner" />
      <h3>Loading reservations</h3>
      <p>Please wait while we load your confirmed bookings.</p>
    </div>
  );

  renderError = () => (
    <div className="reservation-state">
      <div className="reservation-state-icon reservation-error-icon"><this.AlertIcon /></div>
      <h3>Unable to load reservations</h3>
      <p>{this.state.error}</p>
      <button
        type="button"
        className="reservation-action-button"
        onClick={() => {
          const web_user_id = localStorage.getItem("web_user_id") || sessionStorage.getItem("web_user_id");
          if (web_user_id) this.fetchReservations(web_user_id);
        }}
      >
        <this.RefreshIcon />
        <span>Try Again</span>
      </button>
    </div>
  );

  renderEmpty = () => (
    <div className="reservation-state">
      <div className="reservation-state-icon reservation-empty-icon"><this.EmptyIcon /></div>
      <span className="reservation-empty-badge">No confirmed bookings</span>
      <h3>No reservations yet!</h3>
      <p>You currently do not have any confirmed and paid reservations.</p>
    </div>
  );

  render() {
    const { reservations, loading, error } = this.state;

    return (
      <div className="reservation-view">
        <header className="reservation-page-header">
          <div className="reservation-header-left">
            <div className="reservation-header-icon"><this.CalendarIcon /></div>
            <div>
              <h2 className="reservation-title">Reservations</h2>
              <p className="reservation-subtitle">Manage your confirmed bookings</p>
            </div>
          </div>
          {!loading && !error && reservations.length > 0 && (
            <div className="reservation-count">
              <strong>{reservations.length}</strong>
              <span>{reservations.length === 1 ? "Booking" : "Bookings"}</span>
            </div>
          )}
        </header>

        {loading && this.renderLoading()}
        {!loading && error && this.renderError()}
        {!loading && !error && reservations.length === 0 && this.renderEmpty()}
        {!loading && !error && reservations.length > 0 && (
          <div className="reservation-list">
            {reservations.map(this.renderMobileReservation)}
          </div>
        )}

        {/* POPUPS */}
        {this.renderGuestPopup()}
        {this.renderReviewPopup()}
      </div>
    );
  }
}

export default Reservation;